import React from 'react';

type IconProps = {
  id: string;
  className?: string;
};

export const Icon: React.FC<IconProps> = ({ id, className = 'ic' }) => (
  <svg className={className} aria-hidden="true">
    <use href={`#${id}`} />
  </svg>
);
